@use "@fukuri-admins/ui/layout" as *;

.DefaultLayout {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: background("Primary");
  border-left: 1px solid border("Tertiary");

  &__Header {
    position: sticky;
    top: 0;
    width: 100%;
    display: flex;
    height: 64px;
    justify-content: space-between;
    align-items: center;
    padding: spacing('20') spacing('24');
    background-color: background("Primary");
    border-bottom: 1px solid border("Tertiary");

    &__Title {
      @include typography("Jp/20_W6")
    }
  }

}
